import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ListNotificationSettingsResult } from '../../../shared/models/api-results/notification-setting.api-result';
import { NotificationSettingPayload } from '../../../shared/models/payloads/notification-setting.payload';

@Injectable({
  providedIn: 'root',
})
export class HttpNotificationSettingService {
  constructor(private http: HttpClient) {}

  list() {
    return this.http
      .get(`${environment.api_base_url}/me/list_notifications_settings`)
      .pipe(map((res) => res as ListNotificationSettingsResult));
  }

  update(id: string, payload: NotificationSettingPayload) {
    return this.http.post(
      `${environment.api_base_url}/me/${id}/update_notification_setting`,
      payload
    );
  }
}
